// # Firebase Logger
import { doc, getDoc } from 'firebase/firestore';

class FirestoreLogger {
  constructor() {
    this._stats = {
      reads: 0,
      readTimes: [],
      lastReset: new Date().toISOString()
    };
  }

  // # Get logged document with timing
  async getDocumentWithLogging(docRef) {
    const startTime = performance.now();
    const result = await getDoc(docRef);
    const endTime = performance.now();
    
    this._stats.reads++;
    this._stats.readTimes.push({
      path: docRef.path,
      time: endTime - startTime,
      timestamp: new Date().toISOString()
    });

    // # Keep only last 100 read times
    if (this._stats.readTimes.length > 100) {
      this._stats.readTimes.shift();
    }

    // # Log every 10 reads
    if (this._stats.reads % 10 === 0) {
      this._logStats();
    }

    return result;
  }

  // # Log current stats
  _logStats() {
    const totalTime = this._stats.readTimes.reduce((sum, read) => sum + read.time, 0);
    const avgTime = this._stats.readTimes.length > 0 ? totalTime / this._stats.readTimes.length : 0;

    console.log('Firestore Usage Stats:', {
      totalReads: this._stats.reads,
      averageReadTime: `${avgTime.toFixed(2)}ms`,
      recentReads: this._stats.readTimes.slice(-10),
      since: this._stats.lastReset
    });
  }

  // # Reset stats
  resetStats() {
    this._stats = {
      reads: 0,
      readTimes: [],
      lastReset: new Date().toISOString()
    };
  }

  // # Get current stats
  getStats() {
    return { ...this._stats };
  }
}

const firestoreLogger = new FirestoreLogger();
export default firestoreLogger; 